module.exports = __webpack_public_path__ + "ea780d4c5becb65524e11a6966f1d5c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/wechat_inactive.png
// module id = 580
// module chunks = 0